import type { ReactNode } from 'react';
import { Badge } from '../ui/Badge';

export interface AuthHeroProps {
  badgeIcon?: ReactNode;
  badgeText?: string;
  /** H1 content; highlight a word with `<span className="text-green">`. */
  heading: ReactNode;
  subtitle?: ReactNode;
  /** Max width of the subtitle block (default wraps at max-w-md like Figma's two-line intros). */
  subtitleClassName?: string;
}

/**
 * Centered hero header for the onboarding screens: pill badge, large navy
 * heading with a green highlight word, grey subtitle.
 */
export function AuthHero({
  badgeIcon,
  badgeText,
  heading,
  subtitle,
  subtitleClassName = 'max-w-md',
}: AuthHeroProps) {
  return (
    <header className="flex flex-col items-center gap-4 text-center">
      {badgeText && <Badge icon={badgeIcon}>{badgeText}</Badge>}
      <h1 className="font-sans text-4xl font-bold text-navy sm:text-5xl">{heading}</h1>
      {subtitle && <div className={`text-subtext ${subtitleClassName}`.trim()}>{subtitle}</div>}
    </header>
  );
}
